import {gql} from '@apollo/client';

export const CREATE_CHECKOUT_V2 = gql`
  mutation createCheckoutV2($input: CreateCheckoutV2Input!) {
    createCheckoutV2(input: $input) {
      id
    }
  }
`;

export const CREATE_CHECKOUT_FOR_INSTALLMENT = gql`
  mutation DirectCheckoutCreateInput($input: DirectCheckoutCreateInput!, $basketItem: [BasketItemInput!]!) {
    checkout: createDirectCheckout(input: $input, basketItem: $basketItem) {
      id
      status
    }
  }
`;
